import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allContents: [],
};

export const contentViewSlice = createSlice({
  initialState,
  name: "contentView",
  reducers: {
    setContentView: (state, action) => {
      state.allContents = action.payload;
    },
  },
});

export const { setContentView } = contentViewSlice.actions;

export default contentViewSlice;
